"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_USER_ELIGIBILITY = exports.GET_SECURE_QUESTIONER = exports.GET_SECURE_ANSWERS = exports.GET_NEW_LOYALTICS = exports.GET_LOYALTY_OFFERS = exports.GET_LOYALTY_DATA = exports.GET_LOYALTY_CUSTOMER = exports.GET_LINK_LOYALTY = exports.GET_LINK_ACCOUNT_STATUS = exports.GENERATE_SUPPORT_TICKET = void 0;
const GET_LOYALTY_DATA = exports.GET_LOYALTY_DATA = 'getLoyaltyData';
const GET_LINK_ACCOUNT_STATUS = exports.GET_LINK_ACCOUNT_STATUS = 'getLinkAccountStatus';
const GET_LOYALTY_OFFERS = exports.GET_LOYALTY_OFFERS = 'getLoyaltyOffers';
const GET_LOYALTY_CUSTOMER = exports.GET_LOYALTY_CUSTOMER = 'getLoyaltyCustomer';
const GET_LINK_LOYALTY = exports.GET_LINK_LOYALTY = 'getLinkLoyalty';
const GENERATE_SUPPORT_TICKET = exports.GENERATE_SUPPORT_TICKET = 'genrateSupportTicket';
const GET_NEW_LOYALTICS = exports.GET_NEW_LOYALTICS = 'getNewLoyaltics';
const GET_SECURE_QUESTIONER = exports.GET_SECURE_QUESTIONER = 'getSecureQuestiner';
const GET_USER_ELIGIBILITY = exports.GET_USER_ELIGIBILITY = 'getUserEligibility';
const GET_SECURE_ANSWERS = exports.GET_SECURE_ANSWERS = 'getSecureAnswers';